import React from 'react';
import { Box, Stack } from '@mui/material';
import Links from 'dashboard/components/sidebar/components/Links';
import SidebarBrandMark from 'dashboard/components/sidebar/components/SidebarBrandMark';
import { HSeparator } from 'dashboard/components/separator/Separator';

/**
 * Sidebar body. The selected brand's mark sits at the top; everything below
 * is a vertical list of links. The brand picker and the user menu live in the
 * top navbar so we deliberately don't repeat them here.
 */
export default function SidebarContent({ routes, mini, hovered }) {
  const expanded = mini === false || (mini === true && hovered === true);

  return (
    <Stack direction='column' minHeight='100%' pt='25px' pb='30px' borderRadius='30px'>
      <Stack direction='row' alignItems='center' justifyContent='center' mb='14px' px='10px'>
        <SidebarBrandMark expanded={expanded} />
      </Stack>
      <HSeparator mb='20px' />

      <Box
        sx={{
          pl: expanded ? '20px' : '16px',
          pr: { md: '16px', xl: '1px' },
          ml: mini && !hovered ? '-16px' : 0,
        }}
      >
        <Links mini={mini} hovered={hovered} routes={routes} />
      </Box>
    </Stack>
  );
}
